import { createClient } from '@supabase/supabase-js';

const salesMasteryUrl =
  process.env.REACT_APP_SUPABASE_URL_SALES_MASTERY ||
  process.env.REACT_APP_SUPABASE_URL;

const salesMasteryAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY_SALES_MASTERY ||
  process.env.REACT_APP_SUPABASE_ANON_KEY;

/** Null when env vars are missing (local dev without .env). */
export const supabase =
  salesMasteryUrl && salesMasteryAnonKey
    ? createClient(salesMasteryUrl, salesMasteryAnonKey)
    : null;
